import MACHINING_ORDER from './machining-order'
import PROCESS_TASK from './process-task'
export default {
	'machining-order': MACHINING_ORDER,
	'process-task': PROCESS_TASK
}
